module.exports = __webpack_public_path__ + "static/Commune-Nuit_Debout_web-0cc575ddbe9afbb0821e2bcdd6606708.woff2";